import React, { memo } from 'react'
import { useLocation } from 'react-router-dom'
import { useEventLogger } from './LogContext'

/**
 * Google analytics and Tag Manager don't automatically work with SPA application route changes
 * This middleware manually sends pageviews to Google.
 */
const _NavigationLoggingMiddleware = () => {
  const { navigationEvent } = useEventLogger()
  const { pathname, search, hash } = useLocation()

  // Log navigation events whenever path, search or hash changes
  // we explicitly don't trigger this effect on employee/shop changes.
  // It should ONLY run when navigation changes, and at that point it will pick up fresh vars anyway.
  React.useEffect(() => {
    navigationEvent({ pathname, search, hash })
  }, [pathname, search, hash])

  return null
}

const NavigationLoggingMiddleware: React.FC = memo(_NavigationLoggingMiddleware)
export default NavigationLoggingMiddleware
